// @flow

import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { chatType } from '../../types';
import { hpfetch } from '../util';

export const getSingle = (
  chatId: number,
): Promise<wrappedApiResponseType<chatType>> => hpfetch(`chats/${chatId}/`);

export const getChatMessages = (
  limit: number = 100,
  offset: number = 0,
  chatId: number = 0,
): Promise<wrappedApiResponseType<chatType>> =>
  hpfetch(`chats/${chatId}/messages/?limit=${limit}&offset=${offset}`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<chatType> =>
  hpfetch(`chats/?limit=${limit}&offset=${offset}`);

export const create = (chatId: number, fields: any) =>
  hpfetch(`chats/${chatId}/`, {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const update = (chatId: number, fields: any) =>
  hpfetch(`chats/${chatId}/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });

export const createChat = (fields: any) =>
  hpfetch('chats/', {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const updateLastRead = (chatId: number) =>
  hpfetch(`chats/${chatId}/update_last_read/`, {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const getUnread = () =>
  hpfetch('chats/unread_count/', {
    method: 'GET',
  });

export const reportChat = (chatId: number) =>
  hpfetch(`chats/${chatId}/report/`, {
    method: 'POST',
  });

export const resetPhoneNumbers = () =>
  hpfetch(`chats/wipe_voice_sessions/`, {
    method: 'POST',
  });

export const exists = (content_type: string, id: number) =>
  hpfetch('chats/exists/', {
    method: 'POST',
    body: JSON.stringify({ content_type, id }),
  });
